export default "__VITE_ASSET__9yqrIDJj__"